import { ThemeConfig } from "@chakra-ui/react"

export default <ThemeConfig>{
  initialColorMode: "light",
  useSystemColorMode: true,
  cssVarPrefix: "emenu",
}
